// OptionsOutsideLMI.jsx
import React from "react"
import Select from 'react-select'

export default function OptionsOutsideLMI({
  selectedFilterLMI,
  setSelectedFilterLMI,
  isMulti
}) {

  const optionsEthnicity = [
    {label: "(All)", value: "(All)"},
    {label: "Program Area",
    options:
  [
    {value: "Agriculture Education", label: "Agriculture Education"},
    {value: "Business & Marketing", label: "Business & Marketing"},
    {value: "Family & Consumer Sciences", label: "Family & Consumer Sciences"},
    {value: "Health Sciences", label: "Health Sciences"},
{value: "Skilled & Technical Sciences", label: "Skilled & Technical Sciences"},
{value: "STEM", label: "STEM"},



]},{
  label: "Career Clusters",
  options:
  [
    {value: "Agriculture, Food & Natural Resources (1)", label: "Agriculture, Food & Natural Resources (1)"},
    {value: "Architecture & Construction  (2)", label: "Architecture & Construction  (2)"},
    {value: "Arts, A/V Technology & Communications (3)", label: "Arts, A/V Technology & Communications (3)"},
    {value: "Business, Management & Administration (4)", label: "Business, Management & Administration (4)"},
    {value: "Education & Training (5)", label: "Education & Training (5)"},
    {value: "Finance (6)", label: "Finance (6)"},
    {value: "Government & Public Administration (7)", label: "Government & Public Administration (7)"},
    {value: "Health Science (8)", label: "Health Science (8)"},
    {value: "Hospitality & Tourism (9)", label: "Hospitality & Tourism (9)"},
    {value: "Human Services (10)", label: "Human Services (10)"},
    {value: "Information Technology (11)", label: "Information Technology (11)"},
    {value: "Law, Public Safety, Corrections & Security (12)", label: "Law, Public Safety, Corrections & Security (12)"},
    {value: "Manufacturing (13)", label: "Manufacturing (13)"},
    {value: "Marketing (14)", label: "Marketing (14)"},
    {value: "Science, Technology, Engineering & Mathematics (15)", label: "Science, Technology, Engineering & Mathematics (15)"},
    {value: "Transportation Distribution & Logistics (16)", label: "Transportation Distribution & Logistics (16)"}
  ]}
  ];


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#ffffff',
      cursor:'pointer',
      minHeight: '40px',
      height: '40px',
      boxShadow: state.isFocused ? null : null,
    }),
    input: (provided, state) => ({
      ...provided,
      marginLeft: '2px',
    }),
  }

  const handleRemoveStudentGroup = (e) => {
    if (!setSelectedFilterLMI) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = selectedFilterLMI.find((val) => val.value === buttonName);
    if (!removedValue) return;
    setSelectedFilterLMI(
      selectedFilterLMI.filter((val) => val.value !== buttonName),
      { action: "remove-value", removedValue }
    );
  };

  return (
    <div>
      <span className="text-sm font-medium">Select Program or Cluster:</span>
      <Select
        className="ml-2 min-w-[325px]"
        controlShouldRenderValue={!isMulti}
        maxMenuHeight={800}
        components={{
          DropdownIndicator:() => (
            <div className="pr-2 text-gray-400">
              {/* small arrow icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24"
                strokeWidth="1.5" stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                />
              </svg>
            </div>
          ),
          IndicatorSeparator: () => null
        }}
        onChange={setSelectedFilterLMI}
        options={optionsEthnicity}
        value={selectedFilterLMI}
        styles={customStyles}
        isClearable={false}
        placeholder="Select a program or cluster"
      />
      {/* If you want to display "bubbles" for each filter selection, you'd do it below, but that depends on isMulti usage */}
    </div>
  )
}